<template>
  <div class="row pt-3">
    <div v-for="lang in ['de', 'en']" :key="lang" class="col">
      <div class="form-floating">
        <form-field
          :element="name === 'name_translations' ? 'Form/TextInput.vue' :  'Form/TextArea.vue'"
          :property-elements="value"
          :label="lang"
          :name="lang"
          :placeholder="lang"
          :value="localValue[lang] ?? ''"
          @update:data="(updatedValue) => updateData(updatedValue, lang)"
        >
          <template #label>
            <label :for="lang">
              <locale-flag :locale="getLocale(lang)" :height="'0.5rem'"></locale-flag>
              {{ lang }}</label
            >
          </template>
        </form-field>
      </div>
    </div>
  </div>
</template>

<script>
import FormField from '@kanrisha/components/Form/FormField';
import LocaleFlag from '@kanrisha/components/Misc/LocaleFlag';
import useLocale from '@kanrisha/composables/useLocale';
import { ref } from 'vue';

export default {
  components: {
    FormField,
    LocaleFlag,
  },
  props: {
    name: { type: String, default: () => '' },
    value: { type: Object, default: () => {} },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const { getLocale } = useLocale();

    const localValue = ref(props.value ?? { de: null, en: null });

    const updateData = (val, lang) => {
      localValue.value[lang] = val;
      emit('update:data', localValue.value);
    };

    return {
      getLocale,
      localValue,
      updateData,
    };
  },
};
</script>
